import { validateYupSchema, yupToFormErrors } from 'formik'

import Yup from '@fourthwall/utils/dist/yup'

import type { ProductFormState } from '../SingleProduct/SingleProduct.types'

export const validate = (values: ProductFormState) => (schemas: Record<string, any>) => {
  const combinedSchema = Object.assign({}, ...Object.values(schemas))

  // NOTE: https://github.com/jaredpalmer/formik/issues/506
  try {
    validateYupSchema(values, Yup.object().shape(combinedSchema), true, {
      values,
    })
  } catch (err) {
    return yupToFormErrors(err)
  }

  return {}
}
